import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import PanelGroup from '@creditflowresearch/uilib/PanelGroup';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import { SECTIONS_REGISTRY, type ISectionEntry } from './sectionsRegistry';

export type { ISectionEntry };
export { SECTIONS_REGISTRY };

interface ICorporateBondScreenerSidebarContentProps {
  sections?: ISectionEntry[],
}

export const CorporateBondScreenerSidebarContent = (
  { sections = SECTIONS_REGISTRY }: ICorporateBondScreenerSidebarContentProps,
) => {
  const { filters, isFetching, activeSectionIds, setActiveSectionIds } = useCorporateBondScreenerSidebarFilterContext();

  if (isFetching || !filters) {
    return <Spinner overlay />;
  }

  return (
    <PanelGroup
      dataTest="corporateBondScreenerSidebarContent"
      activeKey={ activeSectionIds }
      onChange={ setActiveSectionIds }
    >
      { sections.map(({ id, Component }) => <Component key={ id } />) }
    </PanelGroup>
  );
};
